define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/def",
    "csi/form/Widget",
    "./CFCAAgent",
    "./main"
], function (declare, lang, def, Widget, CFCAAgent, CFCA) {

    var CFCA_DIGITAL_CERTIFICATE = "CFCADigitalCertificate";

    var SELECT_CFCA_DIGITAL_CERTIFICATE = "SelectCFCADigitalCertificate";

    return declare(Widget, {

        _resolveView: function () {

            // add action to popup selection of certificate
            this.defView._addViewAction(SELECT_CFCA_DIGITAL_CERTIFICATE, {
                m_typeControl: def.ACTION_BUTTON,
                m_onAction: lang.hitch(this, "_onSelectCFCADigitalCertificate")
            });

            this.inherited(arguments);
        },

        onDrawCFCADigitalCertificate: function () {
            CFCA.drawSelectDigitalCertificateButton(this, CFCA_DIGITAL_CERTIFICATE, SELECT_CFCA_DIGITAL_CERTIFICATE);
        },

        _onSelectCFCADigitalCertificate: function () {
            var fieldCertificate = this.defView.getField(CFCA_DIGITAL_CERTIFICATE);
            try {
                var CryptoKit = CFCAAgent.loadObject();
                var CertSubjectDN = CryptoKit.selectCertificate("", "", "");
                if (!CertSubjectDN) {
                    throw new CFCAAgentException();
                }

                var certificate = "";
                var tempThis = this;
                CryptoKit.getSignCertInfo("CertContent")
                    .then(function (response) {
                        tempThis.setFieldValue(fieldCertificate, response.result);
                    })
                    .catch(function (response) {
                        CFCAAgent.ShowErrorInfo(response, CryptoKit);
                    });
            } catch (ex) {
                this._setErrorField(fieldCertificate);
            }
        }
    });
});